import React from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import callapi from '../../helpers/callapi'
import { setAnnouncements } from '../../reducers/admin/adminSlice'

export default function NotificationListItem({ notification }) {
  const dispatch = useDispatch()
  const created = new Date(notification.created._seconds * 1000).toLocaleString('th-TH')
  function handleRead(id) {
    callapi({ url: `/announcements/${id}/read`, method: 'post' })
      .then((res) => {
        callapi({ url: `/admins/me` })
          .then((response) => dispatch(setAnnouncements(response.announcements)))
          .catch((err) => console.log(err))
      })
      .catch((err) => {
        console.log(err)
      })
  }
  return (
    <>
      <div className="d-flex align-items-center">
        <div className="d-flex" style={{ minWidth: '160px' }}>
          {created}
        </div>
        <div className="d-flex flex-grow-1">
          {notification.message}{' '}
          {notification.link && (
            <a
              className="link-primary"
              href={notification.link}
              alt={notification.message}
              style={{ marginLeft: '8px' }}
              rel="noreferrer"
              target="_blank"
            >
              ดูเพิ่มเติม
            </a>
          )}
        </div>
        <div className="d-flex">
          <Button size="sm" className="ml-2" onClick={() => handleRead(notification.id)}>
            อ่านแล้ว
          </Button>
        </div>
      </div>
    </>
  )
}
